/* eslint-disable react/jsx-no-bind */
import React from 'react';
import UserForm from '../UserForm';
import Field from '../Field';
import RichText from '../../Prismic/RichText';

const ShippingMethodsUserForm = props => (
  <UserForm
    {...props}
    renderFields={(field, idx) => {
      if (field.type === 'radio_input') {
        const optionClassName = `${field.type}__option`;
        return (
          <Field
            key={`${field.type}-${idx}`}
            {...props}
            field={field}
            index={idx}
            customLabel={(item) => (
              <div className={`${optionClassName}__content ${optionClassName}__content--shipping-method`}>
                <span className={`${optionClassName}__label ${optionClassName}__label--shipping-method`}>
                  {item.label}
                </span>
                <div className="price--shipping-method">
                  {item.cost.formatted}
                </div>
                <div className={`${optionClassName}__description ${optionClassName}__description--shipping-method`}>
                  <RichText fields={item.description}/>
                </div>
              </div>
            )}
          />
        );
      }
      return <Field key={`${field.type}-${idx}`} {...props} field={field} index={idx}/>;
    }}
  />
);
/* eslint-enable react/jsx-no-bind */

export default ShippingMethodsUserForm;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/CustomForms/ShippingMethods.js